import { createContext, useContext, useState, useEffect, useRef, useCallback, useMemo } from 'react';
import axios from 'axios';
import { io } from 'socket.io-client';
import {
    Dialog, DialogContent, Box, Typography, Button,
} from '@mui/material';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const AuthContext = createContext();

export const AuthProvider = ({ children, connectionString }) => {
    const [user, setUser] = useState(null);
    const [companyData, setCompanyData] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isSuperAdmin, setIsSuperAdmin] = useState(() => {
        try { return JSON.parse(sessionStorage.getItem('isSuperAdmin') || 'false'); } catch { return false; }
    });

    const [configureData, setConfigureData] = useState(null);
    const [kickedReason, setKickedReason] = useState(null);
    // ❌ COMMENTED: Idle session logout logic
    // const [idleWarningOpen, setIdleWarningOpen] = useState(false);
    // const [idleCountdown, setIdleCountdown] = useState(20);
    const socketRef = useRef(null);
    const interceptorRef = useRef(null);
    // ❌ COMMENTED: Heartbeat and idle timer refs
    // const heartbeatRef = useRef(null);
    // const idleWarningTimerRef = useRef(null);
    // const idleLogoutTimerRef = useRef(null);
    // const idleCountdownRef = useRef(null);

    // ❌ COMMENTED: Idle timeout constants
    // const IDLE_TIMEOUT_MS = 29 * 60 * 1000;      // 29 minutes idle → show warning
    // const IDLE_WARNING_SECONDS = 60;              // 60-second countdown before auto-logout (total = 30 min)

    // ❌ COMMENTED: Axios interceptor for SESSION_EXPIRED handling
    // useEffect(() => {
    //     interceptorRef.current = axios.interceptors.response.use(
    //         res => res,
    //         err => {
    //             const isHeartbeat = err?.config?.url?.includes('/session/heartbeat');
    //             if (!isHeartbeat && err?.response?.status === 401 && err?.response?.data?.code === 'SESSION_EXPIRED') {
    //                 console.error('🔴 INTERCEPTOR: SESSION_EXPIRED 401 detected, calling logoutAndClear()');
    //                 logoutAndClearRef.current?.();
    //             } else if (!isHeartbeat && err?.response?.status === 401) {
    //                 console.warn('⚠️ 401 error but not SESSION_EXPIRED:', err?.response?.data?.code);
    //             }
    //             return Promise.reject(err);
    //         }
    //     );
    //     return () => axios.interceptors.response.eject(interceptorRef.current);
    // }, []);

    // ❌ COMMENTED: Clear idle timers function
    // const clearIdleTimers = useCallback(() => {
    //     clearTimeout(idleWarningTimerRef.current);
    //     clearTimeout(idleLogoutTimerRef.current);
    //     clearInterval(idleCountdownRef.current);
    // }, []);

    // ❌ COMMENTED: Idle warning open ref
    // const idleWarningOpenRef = useRef(false);

    // ❌ COMMENTED: Heartbeat useEffect - every 3 minutes POST to /session/heartbeat
    // useEffect(() => {
    //     if (!user) {
    //         if (heartbeatRef.current) {
    //             clearInterval(heartbeatRef.current);
    //             heartbeatRef.current = null;
    //         }
    //         return;
    //     }

    //     const sendHeartbeat = async () => {
    //         const token = sessionStorage.getItem('sessionToken');
    //         if (!token) return;
    //         try {
    //             await axios.post(`${connectionString}/api/session/heartbeat`, {}, {
    //                 headers: { 'x-session-token': token }
    //             });
    //             console.log('✓ Heartbeat successful at', new Date().toLocaleTimeString());
    //         } catch (err) {
    //             if (err?.response?.status === 401 && err?.response?.data?.code === 'SESSION_EXPIRED') {
    //                 console.error('❌ Heartbeat 401 - session expired, showing warning');
    //                 clearIdleTimers();
    //                 idleWarningOpenRef.current = true;
    //                 const countdown = 10;
    //                 setIdleCountdown(countdown);
    //                 setIdleWarningOpen(true);
    //                 let remaining = countdown;
    //                 idleCountdownRef.current = setInterval(() => {
    //                     remaining -= 1;
    //                     setIdleCountdown(remaining);
    //                     if (remaining <= 0) clearInterval(idleCountdownRef.current);
    //                 }, 1000);
    //                 idleLogoutTimerRef.current = setTimeout(() => {
    //                     clearInterval(idleCountdownRef.current);
    //                     idleWarningOpenRef.current = false;
    //                     setIdleWarningOpen(false);
    //                     logoutAndClearRef.current?.();
    //                 }, countdown * 1000);
    //             } else {
    //                 console.warn('⚠️ Heartbeat failed (non-401):', err.message);
    //             }
    //         }
    //     };

    //     const isPageReload = performance.getEntriesByType('navigation')[0]?.type === 'reload';
    //     if (!isPageReload) {
    //         sendHeartbeat();
    //     }
    //     console.log('📍 Heartbeat interval started (every 3 minutes)');
    //     heartbeatRef.current = setInterval(sendHeartbeat, 3 * 60 * 1000);

    //     return () => {
    //         clearInterval(heartbeatRef.current);
    //         heartbeatRef.current = null;
    //     };
    // }, [user, clearIdleTimers]);

    // ❌ COMMENTED: Start idle timers function
    // const startIdleTimers = useCallback(() => {
    //     if (idleWarningOpenRef.current) {
    //         console.log('⏰ [IDLE] Warning already open and being processed, skipping reset');
    //         return;
    //     }

    //     if (idleWarningTimerRef.current) clearTimeout(idleWarningTimerRef.current);
    //     if (idleLogoutTimerRef.current) clearTimeout(idleLogoutTimerRef.current);
    //     if (idleCountdownRef.current) clearInterval(idleCountdownRef.current);

    //     idleWarningTimerRef.current = setTimeout(() => {
    //         console.log(`⏰ [IDLE] ${IDLE_TIMEOUT_MS / 60000} minutes elapsed - showing warning at`, new Date().toLocaleTimeString());
    //         idleWarningOpenRef.current = true;
    //         setIdleCountdown(IDLE_WARNING_SECONDS);
    //         setIdleWarningOpen(true);

    //         let remaining = IDLE_WARNING_SECONDS;
    //         idleCountdownRef.current = setInterval(() => {
    //             remaining--;
    //             setIdleCountdown(remaining);
    //             if (remaining > 0) {
    //                 console.log(`⏰ [COUNTDOWN] ${remaining}s remaining`);
    //             }
    //             if (remaining <= 0 && idleCountdownRef.current) {
    //                 clearInterval(idleCountdownRef.current);
    //                 idleCountdownRef.current = null;
    //             }
    //         }, 1000);

    //         idleLogoutTimerRef.current = setTimeout(() => {
    //             console.log(`⏰ [IDLE] ${IDLE_WARNING_SECONDS}s countdown expired - auto-logout at`, new Date().toLocaleTimeString());
    //             if (idleCountdownRef.current) {
    //                 clearInterval(idleCountdownRef.current);
    //                 idleCountdownRef.current = null;
    //             }
    //             idleWarningOpenRef.current = false;
    //             setIdleWarningOpen(false);
    //             logoutAndClearRef.current?.(true);
    //         }, IDLE_WARNING_SECONDS * 1000);
    //     }, IDLE_TIMEOUT_MS);
    // }, [IDLE_TIMEOUT_MS, IDLE_WARNING_SECONDS]);

    // ❌ COMMENTED: Setup activity listeners and idle timer useEffect
    // useEffect(() => {
    //     if (!user) {
    //         console.log('👤 [LOGOUT] User not found, clearing all timers');
    //         if (idleWarningTimerRef.current) clearTimeout(idleWarningTimerRef.current);
    //         if (idleLogoutTimerRef.current) clearTimeout(idleLogoutTimerRef.current);
    //         if (idleCountdownRef.current) clearInterval(idleCountdownRef.current);
    //         idleWarningOpenRef.current = false;
    //         setIdleWarningOpen(false);
    //         return;
    //     }

    //     console.log('👤 [LOGIN] User found, setting up idle detection');
    //     startIdleTimers();

    //     const resetOnActivity = () => {
    //         if (idleWarningOpenRef.current) {
    //             console.log('👆 [ACTIVITY] Ignored - warning popup showing');
    //             return;
    //         }
    //         startIdleTimers();
    //     };

    //     const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];
    //     events.forEach(e => document.addEventListener(e, resetOnActivity, { capture: true, passive: true }));

    //     return () => {
    //         console.log('🧹 [CLEANUP] Removing listeners (user component unmounting)');
    //         events.forEach(e => document.removeEventListener(e, resetOnActivity, true));
    //     };
    // }, [user, startIdleTimers]);

    // ❌ COMMENTED: Tab Visibility API - pause timers when tab is hidden
    // useEffect(() => {
    //     if (!user) return;

    //     const handleVisibilityChange = () => {
    //         if (document.hidden) {
    //             if (!idleWarningOpenRef.current) {
    //                 console.log('👁️ [VISIBILITY] Tab hidden - pausing idle timers');
    //                 clearIdleTimers();
    //             }
    //         } else {
    //             console.log('👁️ [VISIBILITY] Tab visible - resuming idle timers');
    //             startIdleTimers();
    //         }
    //     };

    //     document.addEventListener('visibilitychange', handleVisibilityChange);
    //     return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    // }, [user, startIdleTimers, clearIdleTimers]);

    // ❌ COMMENTED: Listen for BroadcastChannel messages - sync logout across tabs
    // useEffect(() => {
    //     if (!user) return;

    //     try {
    //         const idleChannel = new BroadcastChannel('idle-activity');
    //         idleChannel.onmessage = (event) => {
    //             console.log('📡 [BROADCAST] Received message:', event.data.type);
    //             if (event.data.type === 'DEVICE_IDLE_LOGOUT') {
    //                 console.log('📡 [BROADCAST] Another tab logged out due to idle');
    //             }
    //         };
    //         return () => idleChannel.close();
    //     } catch (e) {
    //         console.log('ℹ️ BroadcastChannel not supported in this browser');
    //     }
    // }, [user]);

    // ❌ COMMENTED: beforeunload beacon - logout when tab/window closes
    // useEffect(() => {
    //     if (!user) return;

    //     const trackReloadIntent = (e) => {
    //         if (e.key === 'F5' || (e.ctrlKey && (e.key.toLowerCase() === 'r'))) {
    //             sessionStorage.setItem('_reloadIntent', '1');
    //         }
    //     };
    //     document.addEventListener('keydown', trackReloadIntent, true);

    //     const handleBeforeUnload = () => {
    //         const navEntry = performance.getEntriesByType('navigation')[0];
    //         if (navEntry?.type === 'reload') return;

    //         if (sessionStorage.getItem('_reloadIntent')) {
    //             sessionStorage.removeItem('_reloadIntent');
    //             return;
    //         }

    //         const token = sessionStorage.getItem('sessionToken');
    //         if (!token) return;

    //         const payload = JSON.stringify({ sessionToken: token });
    //         const blob = new Blob([payload], { type: 'application/json' });
    //         navigator.sendBeacon(`${connectionString}/api/logout-beacon`, blob);
    //     };

    //     window.addEventListener('beforeunload', handleBeforeUnload);
    //     return () => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //         document.removeEventListener('keydown', trackReloadIntent, true);
    //     };
    // }, [user]);

    const persistSelectedCompany = (company) => {
        if (company && company.CompId !== undefined) {
            localStorage.setItem('selectedCompanyId', company.CompId.toString());
        } else {
            localStorage.removeItem('selectedCompanyId');
        }
    };

    // Restore session on page refresh
    useEffect(() => {
        const restoreSession = async () => {
            const savedUserStr = sessionStorage.getItem('loggedInUser');
            if (!savedUserStr) {
                setLoading(false);
                return;
            }

            // Clear any stale reload-intent flag that survived the reload
            sessionStorage.removeItem('_reloadIntent');

            try {
                const savedUser = JSON.parse(savedUserStr);

                // Restore session token header on page refresh
                const savedToken = sessionStorage.getItem('sessionToken');
                if (savedToken) {
                    axios.defaults.headers.common['x-session-token'] = savedToken;

                    // ❌ COMMENTED: Validate session via heartbeat on restore
                    // try {
                    //     await axios.post(`${connectionString}/api/session/heartbeat`, {}, {
                    //         headers: { 'x-session-token': savedToken }
                    //     });
                    // } catch (hbErr) {
                    //     if (hbErr?.response?.status === 401) {
                    //         sessionStorage.removeItem('loggedInUser');
                    //         sessionStorage.removeItem('sessionToken');
                    //         sessionStorage.removeItem('isSuperAdmin');
                    //         delete axios.defaults.headers.common['x-session-token'];
                    //         setLoading(false);
                    //         return;
                    //     }
                    //     console.warn('⚠️ [RESTORE] Session heartbeat failed (non-401), proceeding:', hbErr.message);
                    // }

                    connectSessionSocket(savedUser.UserId, savedToken);
                }

                const res = await axios.get(`${connectionString}/api/All-companies`, {
                    params: { userId: savedUser.UserId }
                });
                if (res.data.success && res.data.data.length > 0) {
                    const companies = res.data.data;
                    const sa = Boolean(res.data.isSuperAdmin);

                    setUser(savedUser);
                    setCompanyData(companies);
                    setIsSuperAdmin(sa);
                    sessionStorage.setItem('isSuperAdmin', JSON.stringify(sa));

                    const savedCompanyId = Number(localStorage.getItem('selectedCompanyId'));
                    const savedCompany = companies.find(c => c.CompId === savedCompanyId);

                    if (savedCompany) {
                        setSelectedCompany(savedCompany);
                    } else {
                        setSelectedCompany(companies[0]);
                        persistSelectedCompany(companies[0]);
                    }
                } else {
                    throw new Error("No companies");
                }
            } catch {
                sessionStorage.removeItem('loggedInUser');
                sessionStorage.removeItem('isSuperAdmin');
                sessionStorage.removeItem('sessionToken');
                localStorage.removeItem('selectedCompanyId');
                delete axios.defaults.headers.common['x-session-token'];
                if (socketRef.current) { socketRef.current.disconnect(); socketRef.current = null; }
            } finally {
                setLoading(false);
            }
        };

        restoreSession();
    }, [connectionString]);

    useEffect(() => {
  if (!selectedCompany?.CompId || !user?.UserId) {
    setConfigureData([]);
    return;
  }

  const fetchConfigure = async () => {
    try {
      const res = await axios.get(
        `${connectionString}/api/configure/getDetails/${selectedCompany.CompId}`
      );

      setConfigureData(Array.isArray(res.data) ? res.data : []);

    } catch (err) {
      console.error("Config fetch error:", err);
      setConfigureData([]);
    }
  };

  fetchConfigure();
}, [selectedCompany?.CompId, user?.UserId, connectionString]);

    // Trigger UserDefineContext's fetch (mastersalegrid) ~2.8s after
    // user + selectedCompany are ready. Kept separate from UserDefineContext
    // itself so this file doesn't import it (avoids circular provider deps).
    useEffect(() => {
        if (!user?.UserId || !selectedCompany?.CompId) return;

        const timer = setTimeout(() => {
            window.dispatchEvent(new CustomEvent('userDefineTrigger', {
                detail: { companyId: selectedCompany.CompId }
            }));
            window.dispatchEvent(new CustomEvent('configureTrigger', {
                detail: { companyId: selectedCompany.CompId }
            }));
        }, 2800);

        return () => clearTimeout(timer);
    }, [user?.UserId, selectedCompany?.CompId]);

    const connectSessionSocket = (userId, sessionToken) => {
        if (socketRef.current) socketRef.current.disconnect();

        const socket = io(connectionString, {
            auth: { userId, sessionToken },
            transports: ['websocket'],
        });

        socket.on('connect', () => {
            socket.emit('authenticate', { userId, sessionToken });
        });

        socket.on('session:invalidated', ({ reason } = {}) => {
            console.error('🔴 SOCKET: session:invalidated received, reason:', reason);
            setKickedReason(reason || 'Your session was ended from another device.');
        });

        socketRef.current = socket;
    };

    // ❌ COMMENTED: Logout and clear function - handles idle and session expiration logout
    // const logoutAndClear = useCallback(async (isIdleTimeout = false) => {
    //     console.log('🔴 LOGOUT TRIGGERED at', new Date().toLocaleTimeString(), isIdleTimeout ? '(IDLE on THIS DEVICE)' : '(SESSION EXPIRED)');

    //     clearIdleTimers();
    //     setIdleWarningOpen(false);
    //     idleWarningOpenRef.current = false;

    //     const token = sessionStorage.getItem('sessionToken');
    //     const savedUser = sessionStorage.getItem('loggedInUser');
    //     let userId = null;
    //     try { userId = JSON.parse(savedUser)?.UserId; } catch {}

    //     if (isIdleTimeout) {
    //         console.log('⚠️ DEVICE-LEVEL IDLE LOGOUT - clearing THIS device only');
    //         try {
    //             const broadcastChannel = new BroadcastChannel('idle-activity');
    //             broadcastChannel.postMessage({
    //                 type: 'DEVICE_IDLE_LOGOUT',
    //                 deviceId: sessionStorage.getItem('deviceId'),
    //                 timestamp: Date.now()
    //             });
    //             broadcastChannel.close();
    //         } catch (e) {
    //             console.log('ℹ️ BroadcastChannel not available, skipping other-device notification');
    //         }
    //         sessionStorage.removeItem('sessionToken');
    //         sessionStorage.removeItem('loggedInUser');
    //         sessionStorage.removeItem('isSuperAdmin');
    //         delete axios.defaults.headers.common['x-session-token'];
    //         if (socketRef.current) {
    //             socketRef.current.off('session:invalidated');
    //             socketRef.current.disconnect();
    //             socketRef.current = null;
    //         }
    //     } else {
    //         if (token || userId) {
    //             try {
    //                 await axios.post(`${connectionString}/api/logout`, { sessionToken: token, userId });
    //                 console.log('✓ Logout API call successful - invalidated on SERVER');
    //             } catch (err) {
    //                 console.warn('⚠️ Logout API failed:', err.message);
    //             }
    //         }
    //         sessionStorage.removeItem('sessionToken');
    //         sessionStorage.removeItem('loggedInUser');
    //         sessionStorage.removeItem('isSuperAdmin');
    //         delete axios.defaults.headers.common['x-session-token'];
    //         if (socketRef.current) {
    //             socketRef.current.off('session:invalidated');
    //             socketRef.current.disconnect();
    //             socketRef.current = null;
    //         }
    //     }

    //     localStorage.removeItem('selectedCompanyId');
    //     setUser(null);
    //     setCompanyData([]);
    //     setSelectedCompany(null);
    //     setIsSuperAdmin(false);
    //     setLoading(false);
    //     setConfigureData(null);
    //     console.log('✓ Local state cleared on THIS device');
    // }, [connectionString, clearIdleTimers]);

    // ❌ COMMENTED: Keep logoutAndClear in a ref
    // useEffect(() => {
    //     logoutAndClearRef.current = logoutAndClear;
    // }, [logoutAndClear]);

    const login = async (userData, initialCompanies = null, forcedSelectedCompany = null, serverIsSuperAdmin = false) => {
        // Generate unique device ID for this browser/device
        let deviceId = sessionStorage.getItem('deviceId');
        if (!deviceId) {
            deviceId = `${userData.UserId}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
            sessionStorage.setItem('deviceId', deviceId);
            console.log('🔑 [DEVICE] Generated device ID:', deviceId);
        }

        sessionStorage.setItem('loggedInUser', JSON.stringify(userData));

        // Restore session token header if present (set by Login.js before calling login())
        const sessionToken = sessionStorage.getItem('sessionToken');
        if (sessionToken) {
            axios.defaults.headers.common['x-session-token'] = sessionToken;
            connectSessionSocket(userData.UserId, sessionToken);
        }

        let companies = initialCompanies;
        let sa = serverIsSuperAdmin;

        if (!initialCompanies || initialCompanies.length === 0) {
            const res = await axios.get(`${connectionString}/api/All-companies`, {
                params: { userId: userData.UserId }
            });

            if (!res.data.success || !res.data.data?.length) {
                throw new Error("No accessible companies");
            }
            companies = res.data.data;
            sa = Boolean(res.data.isSuperAdmin);
        }

        const finalCompany = forcedSelectedCompany || companies[0];

        setUser(userData);
        setCompanyData(companies);
        setSelectedCompany(finalCompany);
        setIsSuperAdmin(sa);
        sessionStorage.setItem('isSuperAdmin', JSON.stringify(sa));
        persistSelectedCompany(finalCompany);

        console.log('🏢 [LOGIN] companyData:', companies);
        console.log('🏢 [LOGIN] selectedCompany:', finalCompany);
    };

    // ❌ COMMENTED: Handle stay active button click
    // const handleStayActive = useCallback(() => {
    //     console.log('✓ [BUTTON] User clicked "Stay Active" - restarting idle timer on THIS device');

    //     idleWarningOpenRef.current = false;
    //     setIdleWarningOpen(false);

    //     clearTimeout(idleWarningTimerRef.current);
    //     clearTimeout(idleLogoutTimerRef.current);
    //     clearInterval(idleCountdownRef.current);

    //     try {
    //         const broadcastChannel = new BroadcastChannel('idle-activity');
    //         broadcastChannel.postMessage({ type: 'STAY_ACTIVE_THIS_DEVICE' });
    //         broadcastChannel.close();
    //     } catch (e) {
    //         console.log('BroadcastChannel not available');
    //     }

    //     setIdleCountdown(IDLE_WARNING_SECONDS);

    //     startIdleTimers();
    // }, [startIdleTimers]);

    const switchCompany = async (company) => {
        setLoading(true);
        setSelectedCompany(company);
        await persistSelectedCompany(company);
        setLoading(false);
    };

    // ── Logout transition state ────────────────────────────────────────────
    const [logoutPending, setLogoutPending] = useState(false);

    const triggerLogout = useCallback(() => {
        setKickedReason(null);
        setLogoutPending(true);
    }, []);

    const commitLogout = useCallback(async () => {
        try {
            const token = sessionStorage.getItem('sessionToken');
            if (token) {
                await axios.post(`${connectionString}/api/logout`, {}, {
                    headers: { 'x-session-token': token }
                }).catch(() => {});
            }
        } catch {}
        sessionStorage.removeItem('loggedInUser');
        sessionStorage.removeItem('sessionToken');
        sessionStorage.removeItem('isSuperAdmin');
        sessionStorage.removeItem('_reloadIntent');
        delete axios.defaults.headers.common['x-session-token'];
        if (socketRef.current) {
            socketRef.current.disconnect();
            socketRef.current = null;
        }
        setUser(null);
        setCompanyData([]);
        setSelectedCompany(null);
        setKickedReason(null);
        setLogoutPending(false);
    }, [connectionString]);

    // ❌ COMMENTED: Logout function is disabled - using stub
    // const logout = logoutAndClear;
    const logout = triggerLogout;

    // ── Session Heartbeat (every 5 minutes) ─────────────────────────────────
    const heartbeatRef = useRef(null);
    useEffect(() => {
        if (!user) {
            if (heartbeatRef.current) {
                clearInterval(heartbeatRef.current);
                heartbeatRef.current = null;
            }
            return;
        }

        const sendHeartbeat = async () => {
            const token = sessionStorage.getItem('sessionToken');
            if (!token) return;
            try {
                await axios.post(`${connectionString}/api/session/heartbeat`, {}, {
                    headers: { 'x-session-token': token }
                });
                console.log('✓ Heartbeat sent at', new Date().toLocaleTimeString());
            } catch (err) {
                if (err?.response?.status === 401 && err?.response?.data?.code === 'SESSION_EXPIRED') {
                    console.error('❌ Session expired - logging out');
                    setKickedReason('Your session has expired. Please log in again.');
                } else {
                    console.warn('⚠️ Heartbeat failed:', err.message);
                }
            }
        };

        // Send heartbeat immediately on login
        sendHeartbeat();

        // Then send every 5 minutes
        console.log('📍 Heartbeat started (every 5 minutes)');
        heartbeatRef.current = setInterval(sendHeartbeat, 5 * 60 * 1000);

        return () => {
            if (heartbeatRef.current) {
                clearInterval(heartbeatRef.current);
                heartbeatRef.current = null;
            }
        };
    }, [user, connectionString]);

    // ── Logout Beacon (on tab close) ────────────────────────────────────────
    useEffect(() => {
        if (!user) return;

        const handleBeforeUnload = () => {
            const token = sessionStorage.getItem('sessionToken');
            if (token) {
                const blob = new Blob([JSON.stringify({ sessionToken: token })], { type: 'application/json' });
                navigator.sendBeacon(`${connectionString}/api/logout-beacon`, blob);
                console.log('📤 Logout beacon sent');
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [user, connectionString]);

    // Memoize context value to prevent unnecessary re-renders of entire app tree
    // Only recreate when actual values change, not on every parent render
    const contextValue = useMemo(() => ({
        user,
        companyData,
        selectedCompany,
        isSuperAdmin,
        switchCompany,
        login,
        logout,
        loading,
        configureData,
        logoutPending,
        triggerLogout,
        commitLogout,
    }), [
        user,
        companyData,
        selectedCompany,
        isSuperAdmin,
        switchCompany,
        login,
        logout,
        loading,
        configureData,
        logoutPending,
        triggerLogout,
        commitLogout,
    ]);

    return (
        <AuthContext.Provider value={contextValue}>
            {children}

            {/* ❌ COMMENTED: Idle warning popup */}
            {/* <Dialog
                open={idleWarningOpen}
                maxWidth="xs"
                fullWidth
                PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.18)' } }}
            >
                <DialogContent sx={{ p: 0 }}>
                    <Box sx={{ height: 5, background: 'linear-gradient(90deg, #f59e0b 0%, #f97316 100%)' }} />
                    <Box sx={{ px: 3.5, pt: 3.5, pb: 3 }}>
                        <Box sx={{ width: 52, height: 52, borderRadius: 2.5, bgcolor: '#fffbeb', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2.5 }}>
                            <AccessTimeIcon sx={{ fontSize: 26, color: '#f59e0b' }} />
                        </Box>
                        <Typography fontWeight={800} fontSize="1.1rem" color="#0f172a" mb={1}>
                            Still there?
                        </Typography>
                        <Typography fontSize="0.88rem" color="#475569" lineHeight={1.65} mb={1}>
                            You've been inactive for a while.
                        </Typography>
                        <Typography fontSize="0.88rem" color="#475569" lineHeight={1.65} mb={3}>
                            You'll be logged out in{' '}
                            <Typography component="span" fontWeight={800} color="#f59e0b" fontSize="1rem">
                                {idleCountdown}s
                            </Typography>
                        </Typography>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleStayActive}
                            sx={{
                                py: 1.4, borderRadius: 2, fontWeight: 700,
                                fontSize: '0.92rem', textTransform: 'none',
                                background: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)',
                                boxShadow: '0 4px 14px rgba(245,158,11,0.35)',
                                '&:hover': { background: 'linear-gradient(135deg, #d97706 0%, #ea580c 100%)' },
                            }}
                        >
                            OK, Keep me logged in
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog> */}

            {/* Session invalidated popup */}
            <Dialog
                open={!!kickedReason}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        overflow: 'hidden',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
                    },
                }}
            >
                <DialogContent sx={{ p: 0 }}>
                    {/* Red top stripe */}
                    <Box sx={{ height: 5, background: 'linear-gradient(90deg, #dc2626 0%, #ef4444 100%)' }} />

                    <Box sx={{ px: 3.5, pt: 3.5, pb: 3 }}>
                        {/* Icon */}
                        <Box sx={{
                            width: 52, height: 52, borderRadius: 2.5,
                            bgcolor: '#fef2f2', display: 'flex', alignItems: 'center',
                            justifyContent: 'center', mb: 2.5,
                        }}>
                            <LockPersonIcon sx={{ fontSize: 26, color: '#dc2626' }} />
                        </Box>

                        <Typography fontWeight={800} fontSize="1.1rem" color="#0f172a" mb={1}>
                            Session Ended
                        </Typography>

                        <Typography fontSize="0.88rem" color="#475569" lineHeight={1.65} mb={3}>
                            {kickedReason}
                        </Typography>

                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => {
                                setKickedReason(null);
                                triggerLogout();
                            }}
                            sx={{
                                py: 1.4, borderRadius: 2, fontWeight: 700,
                                fontSize: '0.92rem', textTransform: 'none',
                                background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                                boxShadow: '0 4px 14px rgba(220,38,38,0.35)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #b91c1c 0%, #991b1b 100%)',
                                },
                            }}
                        >
                            Back to Login
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
